import SensorDetails from "./SensorDetails";

export default SensorDetails;
